<!--定位-->
<template>
  <div>
    <van-nav-bar
        title="选择城市"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    <div class="location-city">
      <div>
        <van-icon name="location-o" class="icon"/>当前定位：{{cityName}}
      </div>
<!--      <van-search v-model="keyword" placeholder="城市快速搜索" @input="filterCity"/>-->
    </div>

    <div class="hot-city">
      <div>热门城市</div>
      <div class="city-div">
        <div v-for="item in hotCity" :key="item" @click="selectCity(item)">{{item}}</div>
      </div>
    </div>

<!--    <van-cell v-for="ite in cityList1" :key="ite.code" :title="ite.cityName" @click="selectCity(ite.cityName)"/>-->
    <van-index-bar :index-list="indexList">
      <div v-for="item in cityList1" :key="item.initial">
        <van-index-anchor :index="item.initial" />
        <van-cell v-for="ite in item.list" :key="ite.cityCode" :title="ite.cityName" @click="selectCity(ite.cityName)"/>
      </div>
    </van-index-bar>

  </div>
</template>

<script>
const cityData = require('./json/city.json')
import {openingCities} from '@/config/paramsList'
import {getOpenCity} from '@/api/cinema'

export default {
  name: "location",
  components: {},
  props: {},
  data() {
    return {
      // cityList: cityData.city, //引用json数据
      hotCity: openingCities, // 热门城市
      keyword: '', // 快速搜索
      cityList1: [],
      indexList: [], // 索引字符串集合
    }
  },
  methods: {
    onClickLeft(){
      this.$router.back()
    },
    selectCity(item){
      this.$store.state.city.cityName = item
      // this.$store.commit('city/setCity',item)
      this.onClickLeft()
    },
    filterCity(e){
      console.log(e)
      this.cityList1 = this.cityList.filter(item=>item.cityName.includes(e))
    },
    getOpenCity(){
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.cityList1 = []
      getOpenCity().then(res=>{
        if(res.data){
          let arr = Object.keys(res.data)
          this.indexList = arr || []
          if(arr.length){
            arr.map(item => {
              this.cityList1.push({
                initial: item,
                list: res.data[item]
              })
            })
          }
        }
      }).catch(e=>{
        console.log(e)
      }).finally(() => {
        this.$Toast.clear()
      })
    }
  },
  created() {
    this.getOpenCity()
  },
  mounted() {
    // this.cityList1 = this.cityList
  },
  computed: {
    cityName(){
      return this.$store.state.city.cityName
    },
    cityList(){
      return this.$store.state.cinema.cityList
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
  .location-city{
    padding: 20px;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .icon{
    margin-right:10px;
  }
  .hot-city{
    padding: 20px;
    font-size: 20px;
    &>div:first-child{
      margin-bottom:20px;
      margin-left:1.5%;
    }
    .city-div{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      &>div{
        width:30%;
        margin: 1.5%;
        padding: 20px;
        background-color: #F5F5F5;
        text-align: center;
      }
    }
  }
</style>
